export * from './is-browser';
export * from './promise-utils';
export * from './utils';
export * from './log';
export { default as log } from './log';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/utils/index.js
// module id = 13
// module chunks = 0